export default [{
  path: '/das',
  component: {
    name: 'sublimite',
    template: '<router-view />',
    meta: {
      resource: 'sublimite',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    query: {
      busca: '',
      filtroRapido: '',
    },
    name: 'das-view',
    component: () => import('@/app/das/DasView.vue'),
    meta: {
      resource: 'das',
      action: 'read',
      navActiveLink: 'das-view',
      pageTitle: 'Das SN',
      breadcrumb: [
        {
          text: 'Das SN',
          to: { name: 'das-view' },
          active: true,
        },
      ],
    },
  }],
},
]
